// 获取当日事故列表
import request from '../../utils/request'

export function getPatientList(accidentId) {
  return request({
    url: '/bak/hospital/queryPatientInfo?accidentId=' + accidentId,
    method: 'get'
  });
}
//病例
export function getPatientEmrInfo(data) {
  return request({
    url: '/bak/hospital/queryPatientEmrInfo',
    method: 'post',
    data
  });
}
//费用
export function getPatientFeeInfo(data) {
  return request({
    url: '/bak/hospital/queryPatientFeeInfo',
    method: 'post',
    data
  });
}
//检查
export function getPatientPacsInfo(data) {
  return request({
    url: '/bak/hospital/queryPatientPacsInfo',
    method: 'post',
    data
  });
}

//化验
export function getPatientLisInfo(data) {
  return request({
    url: '/bak/hospital/queryPatientLisInfo',
    method: 'post',
    data
  });
}

//发票
export function getPatientInvoiceInfo(data) {
  return request({
    url: '/bak/hospital/queryPatientInvoiceInfo',
    method: 'post',
    data
  });
}
